import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import i18next, { defaultLanguage, allowedLanguages } from '@/i18n'
import store from '@/store'

// Views
import I18nView from '@/views/I18nView'
import Home from '@/views/Home'
import Result from '@/views/Result'
import Questionnaire from '@/views/Questionnaire'
import ThankYou from '@/views/ThankYou'

Vue.use(Router)
Vue.use(Meta)

const routes = [
    {
        path: '/',
        redirect: '/' + ((store.state.app.language) ? store.state.app.language : defaultLanguage)
    },
    {
        path: '/:locale(' + allowedLanguages.join('|') + ')',
        component: I18nView,
        children: [
            {
                path: ':entrypoint(iframe)?',
                name: 'home',
                component: Home
            },
            {
                path: 'questionnaire',
                name: 'questionnaire',
                component: Questionnaire
            },
            {
                path: 'overview/operational-transferability',
                name: 'questionnaire',
                component: Questionnaire
            },
            {
                path: 'operational-transferability',
                name: 'questionnaire',
                component: Questionnaire
            },
            {
                path: 'overview/structural-transferability',
                name: 'questionnaire',
                component: Questionnaire
            },
            {
                path: 'overview/emotional-transferability',
                name: 'questionnaire',
                component: Questionnaire
            },
            {
                path: 'overview/sustainable-profitability',
                name: 'questionnaire',
                component: Questionnaire
            },
            {
                path: 'structural-transferability',
                name: 'questionnaire',
                component: Questionnaire
            },
            {
                path: 'emotional-transferability',
                name: 'questionnaire',
                component: Questionnaire
            },
            {
                path: 'sustainable-profitability',
                name: 'questionnaire',
                component: Questionnaire
            },
            {
                path: 'checklist',
                name: 'result',
                component: Result
            },
            {
                path: 'result',
                name: 'result',
                component: Result
            },
            {
                path: 'success',
                name: 'success',
                component: ThankYou
            }
        ]
    }
]

const router = new Router({
    mode: 'hash',
    // eslint-disable-next-line
    base: (process.env.BASE_URL) ? process.env.BASE_URL : '/',
    routes
})

router.beforeEach((to, from, next) => {
    let newLanguage = to.params.locale

    if (newLanguage) {
        if (newLanguage !== i18next.language) {
            i18next.changeLanguage(newLanguage)
        }
        if (newLanguage !== store.state.app.language) {
            store.commit('app/changeLanguage', newLanguage)
        }
    }

    setTimeout(() => {
        window.scrollTo(0, 0)
    }, 200)

    next()
})

export default router
